<template>
  <a-table
    :loading="loading"
    :columns="columns"
    :row-key="data => data.order_number"
    :data-source="list"
    :scroll="{
      y: 400
    }"
    :custom-row="(record) => ({
      on: {
        click: showDetail(record.order_number)
      }
    })"
    :pagination="false"
    class="table-purchase-order"
  >
    <span slot="customTitleSubtotal">
      <div>{{ $t('purchase.nomralPrice') }}</div>
      <div class="text-muted" v-if="grandTotal">
        Total {{ grandTotal.subTotal | currency }}
      </div>
    </span>

    <span slot="customTitleTotal">
      <div>{{ $t('purchase.total') }}</div>
      <div class="text-muted" v-if="grandTotal">
        Total {{ grandTotal.totalValue | currency }}
      </div>
    </span>

    <template #created_at="record">
      <div> {{ $moment(Number(record) * 1000).format('YYYY-MM-DD hh:mm:ss') }} </div>
    </template>

    <template #total_value="record">
      <div> {{ record | currency }} </div>
    </template>

    <template #subtotal_value="record">
      <div> {{ record | currency }} </div>
    </template>

    <template #status="record">
      <div> {{ parseStatus(record) }} </div>
    </template>

    <template #delivery_date="record">
      <div> {{ $moment(Number(record) * 1000).format('YYYY-MM-DD HH:mm:ss') }} </div>
    </template>
  </a-table>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'component.purchase.tableList',
  props: {
    list: {
      type: Array,
    },
  },
  data: function () {
    return {
      columns: [
        {
          title: this.$t('purchase.poNumber'),
          dataIndex: 'po_number',
          key: 'po_number',
          scopedSlots: { customRender: 'po_number' },
          class: 'align-middle',
          width: 150,
        },
        {
          title: this.$t('purchase.orderNumber'),
          dataIndex: 'order_number',
          key: 'order_number',
          scopedSlots: { customRender: 'order_number' },
          class: 'align-middle',
          width: 175,
        },
        {
          title: this.$t('purchase.createdAt'),
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: { customRender: 'created_at' },
          class: 'align-middle',
          width: 100,
        },
        {
          title: this.$t('purchase.deliveryExpectations'),
          dataIndex: 'delivery_date',
          key: 'delivery_date',
          scopedSlots: { customRender: 'delivery_date' },
          class: 'align-middle',
          width: 125,
        },
        // {
        //   title: this.$t('purchase.payment.method'),
        //   dataIndex: 'payment_method',
        //   key: 'payment_method',
        //   scopedSlots: { customRender: 'payment_method' },
        //   class: 'align-middle text-center',
        //   width: 125,
        // },
        {
          // title: this.$t('purchase.nomralPrice'),
          dataIndex: 'subtotal_value',
          key: 'subtotal_value',
          slots: { title: 'customTitleSubtotal' },
          scopedSlots: { customRender: 'subtotal_value' },
          class: 'align-middle text-center',
          width: 125,
        },
        {
          // title: this.$t('purchase.total'),
          dataIndex: 'total_value',
          key: 'total_value',
          slots: { title: 'customTitleTotal' },
          scopedSlots: { customRender: 'total_value' },
          class: 'align-middle text-center',
          width: 125,
        },
        {
          title: this.$t('purchase.note'),
          dataIndex: 'note',
          key: 'note',
          scopedSlots: { customRender: 'note' },
          class: 'align-middle text-center',
          width: 150,
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
          class: 'align-middle text-center',
          width: 100,
        },
      ],
    }
  },
  computed: {
    ...mapState(['purchase']),
    loading () {
      return this.purchase.loading
    },
    grandTotal () {
      return this.purchase.sumTotalPurchase
    },
  },
  methods: {
    showDetail (param) {
      return (e) => {
        this.$router.push({ path: `/purchase/order/${param}` })
      }
    },
    parseStatus (param) {
      // new, on_process, sent, deliverd, completed => sendiri
      // draft dan waiting_payment => jadi satu
      switch (param) {
        case 'draft':
        case 'waiting_payment':
          return 'Waiting Payment'
        case 'new':
        case 'on_process':
        case 'confirmed':
        case 'ready_to_pickup':
          return 'On Process'
        case 'sent':
          return 'Sent'
        case 'delivered':
          return 'Delivered'
        case 'completed':
          return 'Completed'
        case 'canceled':
        case 'retoured':
        case 'payment_expired':
        case 'payment_unfinish':
        case 'payment_declined':
          return 'Canceled'
        case 'on_cancel_req':
        case 'on_retour_req':
          return 'Cancel Request'
        default:
          return param
      }
    },
  },
}
</script>

<style lang="scss">
.table-purchase-order {
  .ant-table-row {
    cursor: pointer;
  }
}
</style>
